import React from 'react';
import { useParams } from 'react-router-dom';

import { UiComponent, UserGroupComponent } from 'components';
import { UserGroupQuery } from 'queries';

function Detail() {
  const { id } = useParams<{ id: string }>();
  const groupId = Number(id);
  const { data: group } = UserGroupQuery.useGet(groupId);

  if (!group) return null;

  return (
    <>
      <UiComponent.PageTitle>회원 그룹 상세</UiComponent.PageTitle>
      <UserGroupComponent.Info group={group} />
      <div css={{ height: 16 }} />
      <UserGroupComponent.Members groupId={group.id} />
    </>
  );
}

export default Detail;
